import { type LowIncomePersonalInfoViewModel } from "../../lib/types/types";

/**
 * @todo check that obj doesn't have a property name in addition to any required or optional property names
 * @todo move this somewhere generic outside low income
 *
 * This is only set up to check required property names
 *
 * @returns true if every one of the entries in "properties" can be found as a key of "obj"
 */
const hasFields = (obj: Object, properties: string[]) =>
  properties.every((p) => Object.prototype.hasOwnProperty.call(obj, p));

/**
 * @todo check no additional/rogue properties exist
 *
 * @param candidate An object to check
 * @returns boolean - true if candidate is of type LowIncomePersonalInfoViewModel
 */
export function isLowIncomeVM(candidate: Object): candidate is LowIncomePersonalInfoViewModel {
  return hasFields(candidate, [
    "statuses",
    "birthDate",
    "postalCode",
    "firstName",
    "lastName",
    "countryChoice",
    "localeChoice",
    "email",
  ]);
}
